module.exports = __webpack_public_path__ + "img/compilations-active.cc06a3d2.svg";